import { inject, Injectable } from '@angular/core';
import { VipUpgradesEndpoints } from 'app/core/enums/endpoints';
import { ApiService } from 'app/services/api/api.service';
import { UtilsService } from 'app/services/utils.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class VipUpgradesService {
    private _endpoint = VipUpgradesEndpoints;
    private utils = inject(UtilsService);
    private _apiService = inject(ApiService);

    private apiUrl = environment.apiUrl;

    constructor() {}

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------
    // ----------------------------------------------------------------------
    // @ CRUD methods
    // ----------------------------------------------------------------------

    /**
     * @description
     * Get all vip upgrade
     * @returns
     */
    getAll(playdateId: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getAll, playdateId);
    }

    // /**
    //  * @description
    //  * Get single vip upgrade
    //  * @returns
    //  */
    // getOne(id: number): Observable<any> {
    //     return this._apiService.getOne(this._endpoint.getOne, id);
    // }

    /**
     * @description
     * Create a new vip upgrade
     * @returns
     */
    create(vipUpgradesData: any): Observable<any> {
        return this._apiService.post(this._endpoint.create, vipUpgradesData);
    }

    /**
     * @description
     * Update a vip upgrade
     * @returns
     */
    update(vipUpgradesData: string): Observable<any> {
        return this._apiService.update(this._endpoint.patch, vipUpgradesData);
    }

    /**
     * @description
     * Delete a vip upgrade
     * @returns
     */
    delete(payload: any): Observable<any> {
        return this._apiService.deleteWithParam(this._endpoint.delete, payload);
    }
}
